// Utilities extracted from NavigationModule.js

import _ from "lodash";
import { goToAppStore } from "Utils";
import { SAA_PORTFOLIO_REVAMP_PERM } from "Teacher/routes/Projects/Constants/stringConstants";
import { CAMPAIGN_KEYWORDS } from "./NavigationConstants";
import { COMBINE_CURRICULUM_HOME_PAGE_PERMISSION } from "Constants/permissionConstants";
import ACLStore from "lib/aclStore";

export const campaignParams = ({ query = {} }) => {
  const params = {};
  const first_params = {};
  _.forEach(CAMPAIGN_KEYWORDS, campaign => {
    const { value, key } = campaign;
    const queryValue = query[key] ? query[key] : value;
    if (queryValue) {
      params[`${key} [last touch]`] = queryValue;
      first_params[`${key} [first touch]`] = queryValue;
    }
  });

  try {
    if (localStorage) {
      localStorage.campaignParams = JSON.stringify({ params, first_params });
    }
  } catch (err) {
    console.error(err);
  }
};

export const getPathFromFullPath = (full_path = "") => {
  const path_arr = _.split(full_path, "/");
  const path = _.last(path_arr);

  return path;
};

export const getQueryUpdatedQueryString = ({
  url,
  params,
  paramsToBeRemoved = [],
}) => {
  if (url) {
    //paramsToBeRemoved refers to array of paramKeys that need to be removed from url
    const currentQueryString = _.replace(url, "?", "");
    const currenQueryArray = _.split(currentQueryString, "&");

    let currenQueryParams = {};
    _.forEach(currenQueryArray, arrValue => {
      const paramValue = _.split(arrValue, "=");
      if (_.get(paramValue, "length", 0) > 1) {
        currenQueryParams = {
          ...(currenQueryParams || {}),
          [paramValue[0]]: paramValue[1],
        };
      }
    });

    params = { ...(currenQueryParams || {}), ...(params || {}) };
  }
  const nullKeys = _.filter(
    Object.keys(params || {}),
    key => !_.get(params, key, "") || _.includes(paramsToBeRemoved, key)
  );

  params = _.omit(params, [...nullKeys]);

  const queryString = _.join(
    _.map(params, (val, key) => `${key}=${val}`),
    "&"
  );
  return queryString;
};

/**
    This function retrieves the route value following a specified parameter.
    Given a route in the format 'abc/def/123/academic-honesty/345',
    passing '123' as the parameter will return the route value 'academic-honesty/345'.
  */
export const getRouteAfterParam = ({ pathname, param }) => {
  const pathSegments = _.split(pathname, "/");
  const paramIndex = _.findIndex(pathSegments, segment =>
    _.isEqual(segment, param)
  );

  if (!_.isEqual(paramIndex, -1) && paramIndex < _.size(pathSegments) - 1) {
    const routeSegments = _.slice(pathSegments, paramIndex + 1);
    const route = _.join(routeSegments, "/");
    return `${route}`;
  } else {
    return null;
  }
};

export const handlePipsMobileRedirection = ({ userType, idToken, school }) => {
  let deepLink;
  const schoolParam = school ? `&school=${school}` : "";

  switch (userType) {
    case "staff":
      deepLink = encodeURI(
        `toddle-teacher://orgWorkspaceLogin/?type=pips_mobile_redirect&id_token=${idToken}${schoolParam}`
      );
      break;
    case "student":
      deepLink = encodeURI(
        `toddle-student://orgWorkspaceLogin/?type=pips_mobile_redirect&id_token=${idToken}${schoolParam}`
      );
      break;
    case "parent":
      deepLink = encodeURI(
        `toddle-family://orgWorkspaceLogin/?type=pips_mobile_redirect&id_token=${idToken}${schoolParam}`
      );
      break;
  }

  // Attempt to open the deep link
  if (deepLink) {
    window.location.href = deepLink;
  }
};

export const handleSchoolLoginMobileRedirection = ({
  userType,
  schoolCode,
}) => {
  const appSchemeMap = {
    staff: "toddle-teacher",
    student: "toddle-student",
    parent: "toddle-family",
  };
  const appScheme = appSchemeMap[userType];
  if (!appScheme) return;

  window.location.href = encodeURI(
    `${appScheme}://login/?type=school_login_mobile_redirect&school=${schoolCode}`
  );
};

export const handleSamlMobileRedirection = ({
  userTypeParams,
  queryString,
}) => {
  let deepLink;
  let appName = "FAMILY_MEMBER";

  if (userTypeParams === "staff") {
    deepLink = encodeURI(
      `toddle-teacher://login/?type=saml_mobile_redirect&${queryString}`
    );
    appName = "STAFF";
  } else if (userTypeParams === "student") {
    deepLink = encodeURI(
      `toddle-student://login/?type=saml_mobile_redirect&${queryString}`
    );
    appName = "STUDENT";
  } else if (userTypeParams === "parent") {
    deepLink = encodeURI(
      `toddle-family://login/?type=saml_mobile_redirect&${queryString}`
    );
    appName = "FAMILY_MEMBER";
  }
  handleAppRedirection({ deepLink, appName });
};

export const handleBlackbaudMobileRedirection = ({
  userType,
  idToken,
  schoolName,
  isToddleInitiated,
}) => {
  let deepLink;
  let appName = "FAMILY_MEMBER";

  switch (userType) {
    case "staff":
      deepLink = encodeURI(
        `toddle-teacher://login/?type=blackbaud_mobile_redirect&id_token=${idToken}&school=${schoolName}&isToddleInitiated=${isToddleInitiated}`
      );
      appName = "STAFF";
      break;
    case "student":
      deepLink = encodeURI(
        `toddle-student://login/?type=blackbaud_mobile_redirect&id_token=${idToken}&school=${schoolName}&isToddleInitiated=${isToddleInitiated}`
      );
      appName = "STUDENT";
      break;
    case "parent":
      deepLink = encodeURI(
        `toddle-family://login/?type=blackbaud_mobile_redirect&id_token=${idToken}&school=${schoolName}&isToddleInitiated=${isToddleInitiated}`
      );
      appName = "FAMILY_MEMBER";
      break;
  }
  handleAppRedirection({ deepLink, appName });
};

export const handleVeracrossMobileRedirection = ({
  userType,
  idToken,
  schoolName,
  isToddleInitiated,
}) => {
  let deepLink;
  let appName = "FAMILY_MEMBER";

  switch (userType) {
    case "staff":
      deepLink = encodeURI(
        `toddle-teacher://login/?type=veracross_mobile_redirect&id_token=${idToken}&school=${schoolName}&isToddleInitiated=${isToddleInitiated}`
      );
      appName = "STAFF";
      break;
    case "student":
      deepLink = encodeURI(
        `toddle-student://login/?type=veracross_mobile_redirect&id_token=${idToken}&school=${schoolName}&isToddleInitiated=${isToddleInitiated}`
      );
      appName = "STUDENT";
      break;
    case "parent":
      deepLink = encodeURI(
        `toddle-family://login/?type=veracross_mobile_redirect&id_token=${idToken}&school=${schoolName}&isToddleInitiated=${isToddleInitiated}`
      );
      appName = "FAMILY_MEMBER";
      break;
  }
  handleAppRedirection({ deepLink, appName });
};

export const handleClasslinkMobileRedirection = ({ userType, idToken }) => {
  let deepLink;
  let appName = "FAMILY_MEMBER";

  switch (userType) {
    case "staff":
      deepLink = encodeURI(
        `toddle-teacher://login/?type=classlink_mobile_redirect&id_token=${idToken}`
      );
      appName = "STAFF";
      break;
    case "student":
      deepLink = encodeURI(
        `toddle-student://login/?type=classlink_mobile_redirect&id_token=${idToken}`
      );
      appName = "STUDENT";
      break;
    case "parent":
      deepLink = encodeURI(
        `toddle-family://login/?type=classlink_mobile_redirect&id_token=${idToken}`
      );
      appName = "FAMILY_MEMBER";
      break;
  }
  handleAppRedirection({ deepLink, appName });
};

export const openToddleApp = ({ userType = "parent" }) => {
  let deepLink;
  let appName = "FAMILY_MEMBER";

  switch (userType) {
    case "staff":
      deepLink = encodeURI(`toddle-teacher://login`);
      appName = "STAFF";
      break;
    case "student":
      deepLink = encodeURI(`toddle-student://login`);
      appName = "STUDENT";
      break;
    case "parent":
      deepLink = encodeURI(`toddle-family://login`);
      appName = "FAMILY_MEMBER";
      break;
  }

  handleAppRedirection({ deepLink, appName });
};

export const handleAppRedirection = ({
  deepLink,
  appName = "FAMILY_MEMBER",
  useApkDownloadLink = false,
  timeoutMs = 3000,
}) => {
  // Attempt to open the deep link
  window.location.href = deepLink;

  const timeout = setTimeout(function () {
    // Check if the window's location is still the same as the deep link
    if (window.location.href != deepLink) {
      goToAppStore({ appName, useApkDownloadLink });
    }
  }, timeoutMs);

  window.onpagehide = function () {
    clearTimeout(timeout);
  };
};

export const handleSentralMobileRedirection = () => {
  const appName = "STAFF";
  const deepLink = encodeURI(
    "toddle-teacher://login/?type=sentral_mobile_redirect"
  );
  handleAppRedirection({ deepLink, appName });
};

export const handleStudentGoalsAppRedirection = ({ metadata, type }) => {
  const { goalId, studentId, goalTaskId, goalStatus, userType } = metadata;
  let deepLink = "";

  switch (type) {
    case "GOAL_CREATED": {
      if (userType === "staff") {
        deepLink = encodeURI(
          `toddle-teacher://app/goals/${studentId}/goalsFeed`
        );
      } else if (userType === "student") {
        deepLink = encodeURI(`toddle-student://app/goals/goalsFeed`);
      }
      break;
    }
    case "GOAL_MILESTONE_COMPLETED": {
      // Currently there is no deep link for the family app
      if (userType === "staff") {
        deepLink = encodeURI(
          `toddle-teacher://app/goals/${studentId}/goalDetails/${goalId}`
        );
      }
      break;
    }
    case "GOAL_COMPLETED": {
      // Currently there is no deep link for the family app
      if (userType === "staff") {
        deepLink = encodeURI(
          `toddle-teacher://app/goals/${studentId}/goalsFeed/${goalStatus}`
        );
      }
      break;
    }
    case "GOAL_MILESTONE_COMMENT": {
      if (userType === "staff") {
        deepLink = encodeURI(
          `toddle-teacher://app/goals/${studentId}/evidenceCreation/${goalId}/${goalTaskId}`
        );
      } else if (userType === "student") {
        deepLink = encodeURI(
          `toddle-student://app/goals/evidenceCreation/${goalId}/${goalTaskId}`
        );
      }
      break;
    }
    case "GOAL_COMMENT": {
      if (userType === "staff") {
        deepLink = encodeURI(
          `toddle-teacher://app/goals/${studentId}/evidenceCreation/${goalId}`
        );
      } else if (userType === "student") {
        deepLink = encodeURI(
          `toddle-student://app/goals/evidenceCreation/${goalId}`
        );
      }
      break;
    }
    case "GOAL_MILESTONE_CREATED": {
      // Currently there is no deep link for the family app
      if (userType === "student") {
        deepLink = encodeURI(
          `toddle-student://app/goals/goalDetails/${goalId}`
        );
      }
      break;
    }
  }
  handleAppRedirection({ deepLink });
};

const handlePostMobileRedirection = ({ metadata, isParent }) => {
  const { parentId, studentId, courseId, userType } = metadata;
  let deepLink = "";
  const updatedUserType = isParent ? "parent" : userType;
  // Deeplinks information for opening post detail screen
  // teacher: `toddle-teacher://app/course/:courseId/journal/postDetail/:postId`
  // student: `toddle-student://app/course/:courseId/journal/postDetail/:postId`
  // parent: `toddle-family://app/:studentId/course/:courseId/journal/postDetail/:postId`

  if (_.isEmpty(parentId) || _.isEmpty(courseId) || _.isEmpty(updatedUserType))
    return;

  switch (updatedUserType) {
    case "staff":
      deepLink = `toddle-teacher://app/course/${courseId}/journal/postDetail/${parentId}/post`;
      break;
    case "student":
      deepLink = `toddle-student://app/course/${courseId}/journal/postDetail/${parentId}/post`;
      break;
    case "parent":
      if (_.isEmpty(studentId)) return;
      deepLink = `toddle-family://app/${studentId}/course/${courseId}/journal/postDetail/${parentId}/post`;
      break;
  }

  if (!_.isEmpty(deepLink)) handleAppRedirection({ deepLink });
};

const getIsSaaRevampEnabled = () => {
  return ACLStore.can(SAA_PORTFOLIO_REVAMP_PERM);
};

export const getIsCombineCurriculumHomePageEnabled = () =>
  ACLStore.can(COMBINE_CURRICULUM_HOME_PAGE_PERMISSION);

export const getInitialCurriculumProgramIdFromSearchParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("initialCurriculumProgramId");
};

// Auto-generated exports
export { handlePostMobileRedirection, getIsSaaRevampEnabled };
